module.exports = __webpack_public_path__ + "static/media/animal-pig3.3a8dad10.aac";